<template>
  <v-layout justify-center>
    <v-dialog v-model="dialogVisibility" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text v-html="message"/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('cancel')">{{ cancelAction }}</v-btn>
          <v-btn flat color="primary" @click="$emit('confirm')">{{ confirmAction }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AlertModal',

  props: {
    visibility: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: false
    },

    message: {
      type: String,
      required: false
    },

    confirmAction: {
      type: String,
      required: true
    },

    cancelAction: {
      type: String,
      required: true
    }
  },

  computed: {
    dialogVisibility: {
      get () {
        return this.visibility
      },

      set () {
        this.$emit('cancel')
      }
    }
  }
}
</script>
